import { axios } from "../../helper/axios";
import { AdminTableconstant } from "./AdminTableConstant";

const AdminTableApi = {};

AdminTableApi.getAdminTable = (payload) => {
  if (payload) {
    return axios.get(AdminTableconstant.ADMIN_TABLE_API, {
      params: { city: payload },
    });
  }

  return axios.get(AdminTableconstant.ADMIN_TABLE_API);
};

export { AdminTableApi };
